<input 
      type="radio" 
      [id]="'radioRenderer_' + params.node.id" 
      [name]="'radioGroup_' + params.node.rowIndex" 
      [checked]="params.node.isSelected()" 
      (change)="onChange($event)" 
    />
    <label [for]="'radioRenderer_' + params.node.id"></label>